import React from "react";
import { useNavigate } from "react-router-dom";

interface EmptyStateProps {
  state?: "loading" | "empty" | "error" | "not-enough-data";
  icon?: string;
  title: string;
  description?: string;
  actualDays?: number;
  requiredDays?: number;
  cta?: { label: string; href?: string; onClick?: () => void };
}

export function EmptyState({ state = "empty", icon, title, description, actualDays, requiredDays, cta }: EmptyStateProps) {
  const navigate = useNavigate();

  const defaultIcons: Record<string, string> = {
    loading: "hourglass_empty",
    empty: "inbox",
    error: "error_outline",
    "not-enough-data": "hourglass_empty",
  };

  const resolvedIcon = icon || defaultIcons[state] || "inbox";
  const progress = requiredDays && actualDays != null ? Math.min((actualDays / requiredDays) * 100, 100) : undefined;

  if (state === "loading") {
    return (
      <div className="empty-state-v3">
        <span className="material-symbols-outlined empty-icon" style={{ animation: "spin 1.5s linear infinite" }}>
          progress_activity
        </span>
        <h4 className="empty-title">{title || "Đang tải..."}</h4>
      </div>
    );
  }

  return (
    <div className="empty-state-v3">
      <span className="material-symbols-outlined empty-icon">{resolvedIcon}</span>
      <h4 className="empty-title">{title}</h4>
      {description && <p className="empty-desc">{description}</p>}
      {state === "not-enough-data" && progress != null && (
        <div className="empty-progress">
          <div className="empty-progress-bar" style={{ width: `${progress}%` }} />
        </div>
      )}
      {state === "not-enough-data" && actualDays != null && requiredDays != null && (
        <p className="empty-desc" style={{ fontSize: "var(--text-xs)" }}>
          Đã có {actualDays} / {requiredDays} ngày dữ liệu
        </p>
      )}
      {cta && (
        <button
          className="empty-cta"
          onClick={() => {
            if (cta.onClick) cta.onClick();
            else if (cta.href) navigate(cta.href);
          }}
        >
          {cta.label}
        </button>
      )}
    </div>
  );
}
